<template>
  <v-container fluid>
    <v-alert type="error"
             max-width="600"
             class="mx-auto mt-5"
             prominent>
      <h2>404 Page not found</h2>
      The {{ path }} page was not found.
    </v-alert>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      path: this.$route.path,
    };
  },
};
</script>